<template>
	<div class="ReSearchObjects">
        <tabs type="primary" 
			:activeTab="value"
			@change="OnTabChange"
            tabContentClasses="tab-opt"
            centered
            inline
            round	
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
            class="card card-plain">
            <tab-pane id="complex" >
				<template v-slot:label>
					<span class="tab-label">
						<i class="tab-icon tim-ic ic-gk-building"></i><span>Жилые комплексы</span>
					</span>
				</template>
				
				<div v-if="value == 'complex'">
					<h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>				
					<ReSearchObjSmall v-for="complex in masObjects" :key="complex.id" :objData="complex"/>
				</div>
            </tab-pane>

            <tab-pane id="flat" class="flat">
				<template v-slot:label>
					<span class="tab-label">
						<i class="tab-icon tim-icons icon-components"></i><span>Планировки</span>
					</span>
				</template>
				<div class="card-wrapper" v-if="value == 'flat'">
					<div class="card-wrapper-center row px-3">
						<h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>
						<ReSearchObjGrouping v-for="flat in masObjects" :key="flat.id" :objData="flat"/>
					</div>
				</div>
            </tab-pane>

            <tab-pane id="complexmap" >
				<template v-slot:label>
					<span class="tab-label">
						<i class="tab-icon tim-icons icon-map-big"></i><span>Карта</span>
					</span>
				</template>
				<div class="row justify-content-center px-3" v-if="value == 'complexmap'">
					<h3 class="text-center" v-if="masObjects.length==0">Ничего не найдено</h3>
					<ReSearchObjMap :objData="masObjects"/>
				</div>
            </tab-pane>
        </tabs>

	</div>
</template>

<script>
	import { TabPane, Tabs } from 'src/components';
	import ReSearchObjSmall from 'src/our_modules/SearchSendObjects/ReSearchObjSmall.vue'; 
	import ReSearchObjGrouping from 'src/our_modules/SearchSendObjects/ReSearchObjGrouping.vue'; 
	import ReSearchObjMap from 'src/our_modules/SearchSendObjects/ReSearchObjMap.vue'; 
	//import { Loading } from 'element-ui';

	export default {
		name: 'ReSearchObjects',
		components: {
            TabPane, 
			Tabs,
			ReSearchObjSmall,
			ReSearchObjGrouping,
			ReSearchObjMap,
			//Loading,

		},
		props: {
			masObjects: [Array,Object],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			value: {
				type: String,
				default: 'complex', // flat||complex||complexmap
			}, 
		},
		data () {
			return {
				ver: 1,
				fullscreenLoading: false,
				/*
				bIsObject: this.IsObject(),
				bIsFlat: this.IsFlat(),
				bIsMap: this.IsMap(),*/
			}
		},
		computed: {

		},
		methods: {
			OnTabChange(strTabId){
				this.$emit('input', strTabId);
				this.$emit('change', strTabId);
			},
		},
	}
</script>
<style scoped>
.ReSearchObjects >>> .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.ReSearchObjects >>> .tab-content {margin-top: 15px;}

.card-wrapper {width: 100%; }
.card-wrapper-center {
    justify-content: center;
    margin: 0 auto;
    display: flex;
	max-width: 3000px;
}

/*===media===============================*/
@media (max-width: 768px) {
	.flat .row {width: 100%; margin-left: 0px;}
}

</style>
